import type { AnyAction, Dispatch } from 'redux';
import type { StateTree } from '@makemydeal/dr-dash-types';
import { INSURANCE_FORM_ANALYTICS } from '@makemydeal/dr-shared-components';
import * as insuranceActionCreators from '@makemydeal/dr-dash-store/actions/insuranceActionsCreators';

export const createInsuranceAnalyticsHandler = (dispatch: Dispatch<AnyAction, StateTree>) => (type: string) => {
    switch (type) {
        case INSURANCE_FORM_ANALYTICS.SEARCH_INSURANCE_PROVIDER_NAME:
            dispatch(insuranceActionCreators.searchInsuranceProviderName());
            break;
        case INSURANCE_FORM_ANALYTICS.SELECT_INSURANCE_PROVIDER_NAME:
            dispatch(insuranceActionCreators.selectInsuranceProviderName());
            break;
        case INSURANCE_FORM_ANALYTICS.AUTOCOMPLETE_INSURANCE_PROVIDER_NAME:
            dispatch(insuranceActionCreators.autocompleteInsuranceProviderName());
            break;
    }
};
